// Auto logout on a rejected token is allowed once per window. If the 401 comes straight back
// (e.g. Auth0 silently re-authenticates the same invalid account via social/SSO), a second
// automatic logout would loop forever — the user gets the manual re-login screen instead.
export const AUTO_LOGOUT_KEY = 'autoLogoutAt'
const AUTO_LOGOUT_WINDOW_MS = 2 * 60 * 1000

// sessionStorage survives the Auth0 logout/login redirects within the same tab.
export const shouldAutoLogout = (now = Date.now()): boolean => {
  try {
    const last = Number(sessionStorage.getItem(AUTO_LOGOUT_KEY))
    return !last || now - last > AUTO_LOGOUT_WINDOW_MS
  } catch {
    return false
  }
}

export const markAutoLogout = (now = Date.now()) => {
  try {
    sessionStorage.setItem(AUTO_LOGOUT_KEY, String(now))
  } catch {
    // storage unavailable — shouldAutoLogout already returns false in that case
  }
}

export const clearAutoLogout = () => {
  try {
    sessionStorage.removeItem(AUTO_LOGOUT_KEY)
  } catch {
    // ignore
  }
}
